import { forwardRef } from '@chakra-ui/react';

import { Flex, type FlexProps } from '@frontend/components';

export type ThumbnailContainerProps = FlexProps & {
  isBoxShadowVisible?: boolean;
  isBorderRadius?: boolean;
  borderColor?: string;
};

export const ThumbnailContainer = forwardRef<ThumbnailContainerProps, 'div'>(
  ({ isBoxShadowVisible, isBorderRadius, borderColor, ...restProps }, ref) => {
    return (
      <Flex
        ref={ref}
        position="relative"
        justifyContent="center"
        alignItems="center"
        alignSelf="center"
        height="100%"
        width="100%"
        border={borderColor ? '1px solid' : ''}
        borderColor={borderColor}
        borderRadius={isBorderRadius ? '2px' : 'inherit'}
        boxShadow={
          isBoxShadowVisible ? `inset 0px 0px 4px rgba(0, 0, 0, 0.25)` : ''
        }
        textAlign="center"
        fontWeight={600}
        background="linear-gradient(150deg, #fff 0%, #cccccc 100%)"
        {...restProps}
      />
    );
  },
);
